var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRecentSearchDeleteIcon = function SvgRecentSearchDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16.123 16.121"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4260",
    fill: "none",
    stroke: "#414e5f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2182",
    d: "M15.046 1.066 1.065 15.042"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2183",
    d: "m15.061 15.061-14-14"
  }))));
};
export default SvgRecentSearchDeleteIcon;